export default {
  data() {
    return  {
      localizeRegimeUnits: [
        {
          key: 'milligram(s)',
          value: 'message.medicationRegimeMilligrams'
        },
        {
          key: 'gram(s)',
          value: 'message.medicationRegimeGrams'
        },
        {
          key: 'drop(s)',
          value: 'message.medicationRegimeDrops'
        },
        {
          key: 'tablespoon(s)',
          value: 'message.medicationRegimeTablespoons'
        },
        {
          key: 'microgram(s)',
          value: 'message.medicationRegimeMicrograms'
        },
        {
          key: 'tablet(s)',
          value: 'message.medicationRegimeTablets'
        },
        {
          key: 'capsule(s)',
          value: 'message.medicationRegimeCapsules'
        },
        {
          key: 'milliliter(s)',
          value: 'message.medicationRegimeMilliliters'
        },
        {
          key: 'teaspoon(s)',
          value: 'message.medicationRegimeTeaspoons'
        },
        {
          key: 'minute(s)',
          value: 'message.medicationRegimeMinutes'
        },
        {
          key: 'hour(s)',
          value: 'message.medicationRegimeHours'
        },
        {
          key: 'units(s)',
          value: 'message.medicationRegimeUnits'
        }
      ]
    }
  },
  methods: {
    localizeRegime(key) {
      let self = this;
      let label = self.localizeRegimeUnits.filter(function (item) {
        return String(item.key) === String(key);
      });

      if(label.length === 1) {
        return self.$t(label[0].value);
      }


    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/MedicationRegimes/index.js